/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для формы сброса пароля
   */
  app.PasswordResetFormView = app.CommonAuthFormView.extend({
    el: '#reset-password-form',
    formName: 'reset',
    formElement: '.field_input',
    
    events: {
      'click .button_blue': 'submit',
      'blur .input': 'validate'
    },
    
    run: function () {
      app.CommonAuthFormView.prototype.run.apply(this);
      this.model = new app.PasswordResetForm();
      new app.PasswordInputView();
      new app.PasswordInputView({el: '.confirm-password'});
    }
  });
})();

}.call(window));